import React, { memo } from 'react';
import { Tooltip } from '@cognitiv/cyprus-ui';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BreadcrumbTooltipProps } from 'ducks/types/prop-types';
import { useSwitchTheme } from 'hooks/useSwitchTheme';

import cn from 'components/tooltips/Tooltips.module.scss';

export const BreadcrumbTooltipBase = ({ tooltip }: BreadcrumbTooltipProps) => {
  const { theme } = useSwitchTheme();

  return (
    <div className={cn.relative}>
      <Tooltip theme={theme.tooltip} tooltip={tooltip} position={{ right: 50 }} caret="right" width="max-content" />
      <FontAwesomeIcon icon={faPlus} />
    </div>
  );
};

export const BreadcrumbTooltip = memo(BreadcrumbTooltipBase);
